<template>
    <Select2 class="select2-selection__rendered" v-model="select2Value" :options="options" @change="changeValue" v-bind="$attrs" style="width: auto;">
    </Select2>
</template>
<script>
    import store from '@/store';
    import Select2 from '@/components/common/selector/select2/Select2.vue'
    export default {        
        components:{
            "Select2" : Select2
        },
        data(){
            return {
                select2Value: null,
                options: []
            }
        },
        props : {
            value : null,
            enumsFullName : null,
            selectName : null,
        },
        watch: {
            value: {
                handler(newValue, oldValue){
                    this.select2Value = newValue;             
                }
            }
        },
        created(){
            if(this.selectName)
                this.options.push({id : "", text: "---"+this.selectName+"---"});
            for(var key in store.enum.enums[this.enumsFullName]){
                this.options.push({id: key, text : store.enum.enums[this.enumsFullName][key]});
            }
        },
        methods:{
            changeValue () {
                if(this.select2Value == null || this.select2Value.trim()==""){
                this.$emit("input", null);
                this.$emit("change", null);
                }else{
                this.$emit("input", this.select2Value);
                this.$emit("change", this.select2Value);
                }

            }
        }
    }
</script>
<style>
    .select2-inline {
        float: left;
        width: 250px;
    }
</style>


// WEBPACK FOOTER //
// src/components/common/selector/enums/selectorEnums.vue